import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useWizard } from "../../../../../shared/components/common/ui/Wizard/useWizard";
import { WizardStepper } from "../../../../../shared/components/common/ui/Wizard/WizardStepper";
import { WizardFooter } from "../../../../../shared/components/common/ui/Wizard/WizardFooter";

import use123zapStore from "../../../../../context/123zapStore";

import ExcelStepForm from "./steps/ExcelStepForm";
import ExcelStepMapping from "./steps/ExcelStepMapping";

import useExcelAddController from "../../../hooks/useExcelAddController";

const STEPS = [
  { id: "form", label: "Informações básicas", component: ExcelStepForm },
  { id: "mapping", label: "Mapeamento de dados", component: ExcelStepMapping },
];

export default function PageAddExcel() {
  const navigate = useNavigate();

  const setAlreadyFetchSheets = use123zapStore(
    (state) => state.setAlreadyFetchSheets
  );

  const ctrl = useExcelAddController({ setAlreadyFetchSheets });

  const wizard = useWizard({
    steps: STEPS,
    initialStepId: "form",
  });

  const CurrentStepComponent = wizard.currentStep.component;

  const [formData, setFormData] = useState({
    title: "",
    file: null,
    desc: "",
    formatSheets: "Arquivo Excel",
    deleteDuplicatedVariables: "",
  });

  const [isValid, setIsValid] = useState(false);
  const [attemptedNext, setAttemptedNext] = useState(false);

  const [isChecking, setIsChecking] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setAttemptedNext(false);
  }, [wizard.currentStep.id]);

  const handleNext = async () => {
    if (isChecking || isSaving) return;

    /* STEP 1 — UPLOAD */
    if (wizard.currentStep.id === "form") {
      if (!isValid) {
        setAttemptedNext(true);
        return;
      }

      setIsChecking(true);

      const success = await ctrl.handleCheckExcelPermission(formData);

      setIsChecking(false);

      if (!success) return;

      wizard.next();
      return;
    }

    /* STEP 2 — MAPPING */
    if (wizard.currentStep.id === "mapping") {
      const result = ctrl.validateBeforeFinish();

      if (!result.valid) return;

      let message = "Tem certeza que deseja finalizar a importação?";

      if (result.emptyCount > 0) {
        message =
          `Existem ${result.emptyCount} campos sem seleção.\n\n` +
          "Eles não serão importados.\n\n" +
          "Deseja continuar mesmo assim?";
      }

      if (!window.confirm(message)) return;

      setIsSaving(true);

      await ctrl.handleSubmit({
        formData,
        onSuccess: () => navigate("/listagens"),
      });

      setIsSaving(false);
    }
  };

  const handleBack = () => {
    if (isChecking || isSaving) return;
    wizard.back();
  };

  return (
    <Box sx={{ width: "100%", px: 4, py: 3 }}>
      <WizardStepper
        steps={wizard.steps}
        activeStep={wizard.currentStepIndex}
      />

      <Box sx={{ maxWidth: 860 }}>
        <CurrentStepComponent
          data={wizard.currentStep.id === "form" ? formData : ctrl.dataR}
          updateData={(values) =>
            setFormData((prev) => ({ ...prev, ...values }))
          }
          setIsValid={setIsValid}
          showErrors={attemptedNext}
          setData={ctrl.setDataR}
          variablesByCategory={ctrl.variablesOfTemplate}
          page={ctrl.padronizationPage}
          setPage={ctrl.setPadronizationPage}
        />
      </Box>

      <WizardFooter
        canGoBack={wizard.canGoBack}
        onBack={handleBack}
        onNext={handleNext}
        nextLabel={
          isChecking
            ? "Lendo arquivo..."
            : wizard.currentStep.id === "mapping"
            ? "Finalizar"
            : "Avançar"
        }
        isSaving={isSaving}
        isNextDisabled={isChecking || isSaving}
      />
    </Box>
  );
}
